import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'font-awesome/css/font-awesome.min.css';

import React, {useEffect} from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

import { AuthProvider, useAuth } from './components/AuthContext';

import Header from './components/Header';
import Footer from './components/Footer';
import LandingPage from './components/LandingPage';
import Login from './components/Login';
import SearchForm from './components/SearchForm';
import PricingPlans from './components/PricingPlans';
import AboutUs from './components/Pages/AboutUs';
import ContactUs from './components/Pages/ContactUs';
import Features from './components/Pages/Features';
import Success from './components/Success';
import CookieConsent from "./components/CookieConsent";
import PrivacyPolicy from "./components/Pages/PrivacyPolicy";

function App() {

  ReactGA.initialize(process.env.REACT_APP_TRACKING_ID);

  useEffect(() => {
    ReactGA.send(window.location.pathname + window.location.search);
  }, []);


  return (
    <AuthProvider>
      <Router>
        <AppContent /> {/* ✅ Separate App Layout into AppContent */}
      </Router>
    </AuthProvider>
  );
}

export default App;

/**
 * Component for Main App Content
 */
const AppContent = () => {
  const { user, loading } = useAuth(); // ✅ Get user state

  if (loading) {
    return ('')
  }

  return (
    <div className="d-flex flex-column min-vh-100 custom-search-page">
      {!user && <Header />} {/* ✅ Hide Header if user is logged in */}
      <ShadowAndAnimationWrapper>
        <main className="flex-grow-1">
          <div className="container custom-container my-4">
            <Routes>
              <Route path="/" element={<RootPage />} />
              <Route path="/login" element={<Login />} />
              <Route path="/pricing" element={<PricingPlans />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/contact-us" element={<ContactUs />} />
              <Route path="/features" element={<Features />} />
              <Route path="/success" element={<Success />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            </Routes>
          </div>
        </main>
      </ShadowAndAnimationWrapper>
      <CookieConsent />
      <Footer />
    </div>
  );
};

/**
 * Wrapper Component for Shadow and Animation
 */
const ShadowAndAnimationWrapper = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();

  return (
    <div className="page-wrapper">
      <div className="shadow-circle-blur">
        <div className="shadow-circle"></div>
        {location.pathname === '/' && !user && (
          <div className="animated-circle"></div>
        )}
      </div>
      <div className="content-wrapper">{children}</div>
    </div>
  );
};

/**
 * Component to conditionally render LandingPage or SearchForm based on auth state
 */
const RootPage = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-white" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return user ? <SearchForm /> : <LandingPage />;
};
